import React from 'react';
interface Props {
  title: string;
}
const CommonTitle = (props: Props) => {
  const style: any = {
    fontSize: '14px',
    height: '14px',
    lineHeight: '14px',
    fontFamily: 'PingFangSC',
    fontWeight: '500',
    color: 'rgba(255,255,255,1)',
    borderLeft: '4px solid #0066FF',
    textIndent: '4px',
  };
  return <div style={style}>{props.title}</div>;
};
export default CommonTitle;
